export const TASK_TYPES = [
  { value: 'question', label: 'Pergunta', clinical: false },
  { value: 'prescription', label: 'Receita', clinical: true },
  { value: 'exam_request', label: 'Solicitação de exame', clinical: true },
  { value: 'document', label: 'Documento', clinical: true },
  { value: 'other', label: 'Outro', clinical: false },
];

export const TASK_STATUS = {
  open: 'Aberta',
  answered: 'Respondida',
  cancelled: 'Cancelada',
};

export function taskTypeLabel(value) {
  return TASK_TYPES.find((type) => type.value === value)?.label || 'Tarefa';
}

export function taskError(error) {
  const data = error?.response?.data;
  if (typeof data === 'string' && data !== '') {
    return data;
  }
  const first = data?.errors ? Object.values(data.errors).flat()[0] : null;
  return first || data?.message || 'Não foi possível concluir a tarefa.';
}
